import useStarfishAPI from "../hooks/useStarfishAPI";
import {useEffect} from 'react';

const SubmitStudentAPI = (setWaitingRoomQueueId) => {

  const [response, callSubmitAPI] = useStarfishAPI();

  useEffect(() => {
      if(response.success)
          if(setWaitingRoomQueueId && response.data && response.data.waitingRoomStatus) {
              setWaitingRoomQueueId(response.data.waitingRoomStatus.waitingRoomQueueId);
          }
      }
  );

  const onSubmitStudentApi = (urlParams) => {
    const URL = `../kiosk/signInWaitingRoomStudentWalkIn.html`;
    callSubmitAPI(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: urlParams
    });
  };

  const onSubmitProspectApi = (json) => {
    const URL = `../kiosk/signInProspectWalkIn.html`;
      callSubmitAPI(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: json
    });
  };

  return [response, {onSubmitStudentApi, onSubmitProspectApi}];

};

export default SubmitStudentAPI;
